<template>
  <div style="text-align: left">
    <el-form :inline="true" :model="formInline" class="demo-form-inline"  @keydown.native.enter="$emit('search', formInline)">
      <el-form-item label="物流单号">
        <el-input
          v-model="formInline.expressNo"
          placeholder="物流单号"
        ></el-input>
      </el-form-item>
      <!-- <el-form-item label="异常类型">
        <el-select placeholder="全部" v-model="formInline.abnormalType">
          <el-option label="多件" value="1"></el-option>
          <el-option label="少件" value="0"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="是否丢件" style="display:none">
        <el-select placeholder="全部" v-model="formInline.lossFlag">
          <el-option label="未丢件" value=0></el-option>
          <el-option label="确认丢件" value="1"></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="入库时间">
        <el-date-picker
            v-model="formInline.date"
            @change="dateChange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item> -->
      <el-form-item>
        <el-button
          style="margin-left: 30px"
          type="primary"
          @click="$emit('search', formInline)"
          >搜索</el-button
        >
        <el-button style="margin-left: 10px" @click="rest">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "From",
  data() {
    return {
      formInline: {
        pkgCode: "",
        abnormalType: "",
        expressNo:""
      },
    };
  },
  mounted() {
    this.$emit("search", this.formInline);
  },
  methods: {
    dateChange: function (date) {
      // console.log(val)
      if (!date) {
        this.formInline.createStartTime = null;
        this.formInline.createEndTime = null;
        return;
      }
      this.formInline.createStartTime = date[0].getTime();
      this.formInline.createEndTime = date[1].getTime();
      this.$emit("search", this.formInline);
    },
    rest: function () {
      this.formInline = {
        expressNo: "",
        productSku: "",
        purchaseNo: "",
        systemSource: "",
        packType: "",
        date: [],
        createStartTime: null,
        createEndTime: null,
        day: "",
      };
      this.$emit("search", this.formInline);
    },
  },
};
</script>

<style scoped></style>
